import { render } from "./AddGoCardlessBankAccountModal.vue?vue&type=template&id=4ec688e7"
import script from "./AddGoCardlessBankAccountModal.vue?vue&type=script&lang=js"
export * from "./AddGoCardlessBankAccountModal.vue?vue&type=script&lang=js"

import "./AddGoCardlessBankAccountModal.vue?vue&type=style&index=0&id=4ec688e7&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__